<!-- Page Header -->


<!-- Main Content -->
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <div class="row g-4 align-items-center">
          <div class="col-sm">
            <div>
              <h5 class="card-title mb-0">
                <i class="ri-user-line me-2"></i>Currently Online Users
              </h5>
              <p class="text-muted mb-0">Monitor active users and their activity status</p>
            </div>
          </div>
          <div class="col-sm-auto">
            <div class="d-flex flex-wrap align-items-start gap-2">
              <button type="button" class="btn btn-success" (click)="refreshData()">
                <i class="ri-refresh-line align-bottom me-1"></i> Refresh
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters Section -->
      <div class="card-body border-bottom">
        <div class="row g-3">
          <!-- Search -->
          <div class="col-xxl-4 col-md-6">
            <div class="search-box">
              <input
                type="text"
                class="form-control search"
                placeholder="Search by name or email..."
                [(ngModel)]="searchTerm"
                (input)="onSearch()">
              <i class="ri-search-line search-icon"></i>
            </div>
          </div>

          <!-- User Type Filter -->
          <div class="col-xxl-2 col-md-3">
            <select class="form-select" [(ngModel)]="selectedUserType" (change)="onUserTypeChange()">
              <option value="all">All User Types</option>
              <option *ngFor="let type of userTypes" [value]="type">{{ type }}</option>
            </select>
          </div>

          <!-- Status Filter -->
          <div class="col-xxl-2 col-md-3">
            <select class="form-select" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
              <option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</option>
            </select>
          </div>

          <!-- Results Count -->
          <div class="col-xxl-4 col-md-12">
            <div class="text-muted">
              Showing {{ paginatedUsers.length }} of {{ totalItems }} users
            </div>
          </div>
        </div>
      </div>

      <!-- Table Section -->
      <div class="card-body">
        <div class="table-responsive table-card mb-3">
          <table class="table align-middle table-nowrap table-striped-columns mb-0">
            <thead class="table-light">
              <tr>
                <th scope="col">User</th>
                <th scope="col">Login Time</th>
                <th scope="col">Last Activity</th>
                <th scope="col">Time Since Activity</th>
                <th scope="col">User Type</th>
                <th scope="col">Inactivity Time</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of paginatedUsers; trackBy: trackByUserId">
                <!-- User Information -->
                <td>
                  <div class="d-flex align-items-center">
                    <div class="avatar-xs me-3">
                      <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                        {{ user.name.charAt(0).toUpperCase() }}
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="fs-14 mb-1">{{ user.name }}</h5>
                      <p class="text-muted mb-0">{{ user.email }}</p>
                    </div>
                  </div>
                </td>

                <!-- Login Time -->
                <td>
                  <div class="text-muted">
                    {{ user.loginTime | utcToLocal : 'short' }}
                  </div>
                </td>

                <!-- Last Activity -->
                <td>
                  <div class="text-muted">
                    {{ user.lastActivity | utcToLocal : 'short' }}
                  </div>
                </td>

                <!-- Time Since Last Activity -->
                <td>
                  <div class="text-muted">
                    {{ user.timeLastActivity }}
                  </div>
                </td>

                <!-- User Type -->
                <td>
                  <span [class]="getUserTypeClass(user.userType)">
                    {{ user.userType }}
                  </span>
                </td>

                <!-- Inactivity Time -->
                <td>
                  <div class="text-muted">
                    {{ user.inactivityTime }}
                  </div>
                </td>

                <!-- Status -->
                <td>
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-2">
                      <div class="status-indicator">
                        <div class="status-dot" [class]="getStatusClass(user.status)"></div>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <span class="text-capitalize">{{ user.status }}</span>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- No Data State -->
              <tr *ngIf="paginatedUsers.length === 0">
                <td colspan="7" class="text-center py-4">
                  <div class="d-flex flex-column align-items-center">
                    <i class="ri-user-search-line fs-1 text-muted mb-3"></i>
                    <h5 class="text-muted">No online users found</h5>
                    <p class="text-muted mb-0">Try adjusting your search or filter criteria</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row align-items-center mt-4 pt-3" *ngIf="totalItems > itemsPerPage">
          <div class="col-sm">
            <div class="text-muted">
              Showing <span class="fw-semibold">{{ (currentPage - 1) * itemsPerPage + 1 }}</span>
              to <span class="fw-semibold">{{ Math.min(currentPage * itemsPerPage, totalItems) }}</span>
              of <span class="fw-semibold">{{ totalItems }}</span> results
            </div>
          </div>
          <div class="col-sm-auto">
            <ul class="pagination pagination-separated pagination-sm mb-0">
              <!-- Previous Button -->
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a href="javascript:void(0);" class="page-link" (click)="previousPage()">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>

              <!-- Page Numbers -->
              <li
                *ngFor="let page of pageNumbers"
                class="page-item"
                [class.active]="page === currentPage">
                <a href="javascript:void(0);" class="page-link" (click)="goToPage(page)">
                  {{ page }}
                </a>
              </li>

              <!-- Next Button -->
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a href="javascript:void(0);" class="page-link" (click)="nextPage()">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Summary Cards -->
<div class="row mt-4">
  <div class="col-xl-3 col-md-6">
    <div class="card card-animate">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <p class="text-uppercase fw-medium text-muted mb-0">Total Online</p>
            <h4 class="mb-0">{{ totalItems }}</h4>
          </div>
          <div class="flex-shrink-0">
            <div class="avatar-sm rounded-circle bg-soft-success">
              <div class="avatar-title rounded-circle bg-soft-success">
                <i class="ri-user-line fs-16"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-3 col-md-6">
    <div class="card card-animate">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <p class="text-uppercase fw-medium text-muted mb-0">Active Users</p>
            <h4 class="mb-0">{{ getActiveUsersCount() }}</h4>
          </div>
          <div class="flex-shrink-0">
            <div class="avatar-sm rounded-circle bg-soft-primary">
              <div class="avatar-title rounded-circle bg-soft-primary">
                <i class="ri-user-check-line fs-16"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-3 col-md-6">
    <div class="card card-animate">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <p class="text-uppercase fw-medium text-muted mb-0">Idle Users</p>
            <h4 class="mb-0">{{ getIdleUsersCount() }}</h4>
          </div>
          <div class="flex-shrink-0">
            <div class="avatar-sm rounded-circle bg-soft-warning">
              <div class="avatar-title rounded-circle bg-soft-warning">
                <i class="ri-user-unfollow-line fs-16"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-3 col-md-6">
    <div class="card card-animate">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <p class="text-uppercase fw-medium text-muted mb-0">Away Users</p>
            <h4 class="mb-0">{{ getAwayUsersCount() }}</h4>
          </div>
          <div class="flex-shrink-0">
            <div class="avatar-sm rounded-circle bg-soft-danger">
              <div class="avatar-title rounded-circle bg-soft-danger">
                <i class="ri-user-forbid-line fs-16"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
